<div class="order-edit-delivery">
  <form class="deliveryForm row edit" [formGroup]="deliveryForm">
    <ng-container *ngIf="panelStatus.isEdit">
      <ng-container *ngIf="!panelStatus.isNew && orderDetail.etmOrderNumber">
        <eps-label-body label="ORDERS.FILTER.LABELS.ETM_DOCUMENT_NUMBER" [labelWidth]="labelWidth">
          {{ orderDetail.etmOrderNumber }}
        </eps-label-body>
        <eps-label-body label="ORDERS.FILTER.LABELS.ETM_SHIPPING_NUMBER" [labelWidth]="labelWidth">
          {{ getETMShipmentNumbersAsString(orderDetail.shipmentNumbers) }}
        </eps-label-body>
      </ng-container>

      <eps-radio-group
        formControlName="type"
        [options]="contractInfo.orderTypes"
        (ngModelChange)="orderTypeChanged()"
        [disabled]="busy"
        label="ORDERS.DELIVERY.LABELS.CHOOSE_TYPE"
        [labelWidth]="labelWidth"
        autoSelect
      ></eps-radio-group>

      <!-- shippingConditions -->
      <eps-select
        [options]="shippingConditions"
        formControlName="shippingCondition"
        (ngModelChange)="setFroms()"
        label="ORDERS.DELIVERY.LABELS.SHIPPING_CONDITION"
        [labelWidth]="labelWidth"
        [bindAsObject]="true"
        autoSelect
      ></eps-select>

      <!-- FROM : select -->
      <eps-select
        [options]="froms | filter:'hidden'"
        formControlName="from"
        (ngModelChange)="setTos()"
        label="ORDERS.DELIVERY.LABELS.FROM"
        [labelWidth]="labelWidth"
        [bindAsObject]="true"
        autoSelect
        *ngIf="canEditFromField()"
      ></eps-select>

      <!-- SOLD TO : readonly -->
      <eps-label-body
        label="ORDERS.DELIVERY.LABELS.SOLD_TO"
        [labelWidth]="labelWidth"
        [readonly]="true"
      >{{ deliveryForm.value.soldTo?.name }}</eps-label-body>

      <!-- TO : select -->
      <eps-select
        [options]="tos | filter:'hidden'"
        formControlName="to"
        (ngModelChange)="toChanged()"
        label="ORDERS.DELIVERY.LABELS.TO"
        [labelWidth]="labelWidth"
        autoSelect
        [bindAsObject]="true"
        *ngIf="canEditToField()"
      ></eps-select>

      <!-- INCOTERM : select -->
      <eps-select
        [options]="incoterms"
        formControlName="incoterm"
        (ngModelChange)="incotermChanged()"
        label="ORDERS.DELIVERY.LABELS.INCOTERM"
        [labelWidth]="labelWidth"
        autoSelect
        *ngIf="askIncoterms"
        [bindAsObject]="true"
      ></eps-select>

      <eps-label-body
        [labelWidth]="labelWidth"
        *ngIf="deliveryForm.get('incoterm').errors && askIncoterms"
        @growInOut
        [readonly]="true"
      >
        {{ 'ORDERS.DELIVERY.LABELS.INCOTERM_EMPTY' | translate }}
      </eps-label-body>

      <!-- CUSTOMER REFERENCE NUMBER : text -->
      <eps-text-input
        [labelWidth]="labelWidth"
        label="ORDERS.DELIVERY.LABELS.CUSTOMER_REFERENCE_NUMBER"
        [required]="poNumberMandatory"
        formControlName="customerReferenceNumber"
        [inlineSuffix]="poNumberMask"
        [maxLength]="35"
        [warnings]="receiverRefNrValidationWarningObject"
        [errors]="receiverRefNrValidationErrorObject"
      ></eps-text-input>

      <!-- SENDER REFERENCE NUMBER : text -->
      <eps-text-input
        [labelWidth]="labelWidth"
        label="ORDERS.DELIVERY.LABELS.SENDER_REFERENCE"
        formControlName="senderReferenceNumber"
        [maxLength]="35"
        [warnings]="senderRefNrValidationWarningObject"
        [errors]="senderRefNrValidationErrorObject"
      ></eps-text-input>

      <!-- TRANSPORTER : text -->
      <eps-text-input
        [labelWidth]="labelWidth"
        label="ORDERS.DELIVERY.LABELS.TRANSPORTER"
        formControlName="transporter"
        [maxLength]="10"
        *ngIf="deliveryForm.value.shippingCondition?.id !== 'Z1'"
      ></eps-text-input>

      <!-- LICENCE PLATE : text -->
      <eps-text-input
        [labelWidth]="labelWidth"
        label="ORDERS.DELIVERY.LABELS.LICENCE_PLATE"
        formControlName="licensePlate"
        [maxLength]="15"
        *ngIf="deliveryForm.value.shippingCondition?.id !== 'Z1'"
      ></eps-text-input>

      <div class="col-12 hr-thick"></div>

      <div class="buttons">
        <eps-button
          type="link"
          (buttonClick)="cancelClicked.emit()"
          label="SHARED.BUTTONS.CANCEL"
          *ngIf="panelStatus.isNew"
          minWidth="10px"
        ></eps-button>
        <eps-button
          buttonIcon="check"
          [busy]="(refNrValidationPending | async) === true"
          [disabled]="(refNrValidationPending | async) === true || !deliveryForm.valid"
          (buttonClick)="doNextClicked()"
          [label]="panelStatus.isNew ? 'ORDERS.DELIVERY.BUTTONS.NEXT' : 'ORDERS.DELIVERY.BUTTONS.SAVE'"
          submit
        ></eps-button>
      </div>
    </ng-container>
    <!-- </form> -->

    <!--
  http://patorjk.com/software/taag/#p=display&c=c%2B%2B&f=Big&t=Read%20only%20version
    _____                _               _                            _
   |  __ \              | |             | |                          (_)
   | |__) |___  __ _  __| |   ___  _ __ | |_   _  __   _____ _ __ ___ _  ___  _ __
   |  _  // _ \/ _` |/ _` |  / _ \| '_ \| | | | | \ \ / / _ \ '__/ __| |/ _ \| '_ \
   | | \ \  __/ (_| | (_| | | (_) | | | | | |_| |  \ V /  __/ |  \__ \ | (_) | | | |
   |_|  \_\___|\__,_|\__,_|  \___/|_| |_|_|\__, |   \_/ \___|_|  |___/_|\___/|_| |_|
                                            __/ |
                                           |___/
  -->
    <!--Form displayed when detail is opend  -->
    <!-- <form class="deliveryForm" [formGroup]="deliveryForm" *ngIf="!panelStatus.isEdit"> -->
    <div class="deliveryForm readonly row" [formGroup]="deliveryForm" *ngIf="!panelStatus.isEdit">
      <ng-container *ngIf='!panelStatus.isNew && orderDetail.etmOrderNumber'>
        <div class="col-12 col-sm-6">
          <eps-label-body label="ORDERS.FILTER.LABELS.ETM_DOCUMENT_NUMBER" readonly [labelWidth]="labelWidth">
            {{ orderDetail.etmOrderNumber }}
          </eps-label-body>
        </div>
        <div class="col-12 col-sm-6">
          <eps-label-body label="ORDERS.FILTER.LABELS.ETM_SHIPPING_NUMBER" readonly [labelWidth]="labelWidth">
            {{ getETMShipmentNumbersAsString(orderDetail.shipmentNumbers) }}
          </eps-label-body>
        </div>
      </ng-container>

      <div class="col-12 col-sm-6">
        <eps-select
          [readonly]="true"
          formControlName="type"
          [options]="definitions.order.type"
          label="ORDERS.DELIVERY.LABELS.CHOOSE_TYPE"
          [labelWidth]="labelWidth"
        ></eps-select>
      </div>
      <div class="col-12 col-sm-6" *ngIf="orderDetail.salesOrderNumber">
        <eps-label-body label="ORDERS.FILTER.LABELS.SALES_ORDER_NUMBER" readonly [labelWidth]="labelWidth">
          {{ orderDetail.salesOrderNumber }}
        </eps-label-body>
      </div>

      <div class="col-12 col-sm-6">
        <eps-label-body label="ORDERS.DELIVERY.LABELS.SHIPPING_CONDITION" readonly [labelWidth]="labelWidth">
          {{ deliveryForm?.value?.shippingCondition?.name }}
        </eps-label-body>
      </div>
      <div class="col-12 col-sm-6"
           *ngIf="askIncoterms && orderDetail.deliveryMethod.incoterm && orderDetail.deliveryMethod.incoterm.name && orderDetail.deliveryMethod.incoterm.name !== '-'">
        <eps-label-body label="ORDERS.DELIVERY.LABELS.INCOTERM" readonly [labelWidth]="labelWidth">
          {{ orderDetail.deliveryMethod.incoterm?.name }}
        </eps-label-body>
      </div>

      <!-- arrow header -->
      <ng-container>
          <ng-container *ngIf="showFrom()">
            <div class="col-12 col-md-5 col-sm-6">
              <eps-label-body label="ORDERS.DELIVERY.LABELS.FROM" readonly [labelWidth]="labelWidth">
                {{ orderDetail.deliveryMethod.from?.name }}
              </eps-label-body>
            </div>
            <div class="col-1 hidden-xs hidden-sm" *ngIf="showTo() && resolutionOkForArrow">
              <app-arrow class="myarrow" [width]="60"></app-arrow>
            </div>
          </ng-container>
          <div class="col-6 hidden-xs hidden-sm" *ngIf="!showTo()"></div>
          <div class="col-12 col-sm-6" *ngIf="showTo()">
            <eps-label-body label="ORDERS.DELIVERY.LABELS.TO" readonly [labelWidth]="labelWidth">
              {{ orderDetail.deliveryMethod.to?.name }}
            </eps-label-body>
          </div>
      </ng-container>
      <!--end of arrow header  -->

      <div class="hr"></div>

      <div class="col-12 col-sm-6">
        <eps-label-body label="ORDERS.DELIVERY.LABELS.RECEIVER_REF" readonly [labelWidth]="labelWidth">
          {{ deliveryMethod?.customerReferenceNumber || ('ORDERS.DELIVERY.LABELS.NO_RECEIVER_REF' | translate) }}
        </eps-label-body>
      </div>

      <div class="col-12 col-sm-6" *ngIf="deliveryForm.value.shippingCondition?.id !== 'Z1'">
        <eps-label-body label="ORDERS.DELIVERY.LABELS.TRANSPORTER" readonly [labelWidth]="labelWidth">
          {{ deliveryMethod?.transporter ? deliveryMethod?.transporter : ('ORDERS.DELIVERY.LABELS.NO_TRANSPORTER' | translate) }}
        </eps-label-body>
      </div>

      <div class="col-12 col-sm-6">
        <eps-label-body label="ORDERS.DELIVERY.LABELS.SENDER_REF" readonly [labelWidth]="labelWidth">
          {{ deliveryMethod?.senderReferenceNumber || ('ORDERS.DELIVERY.LABELS.NO_SENDER_REF' | translate) }}
        </eps-label-body>
      </div>
      <div class="col-12 col-sm-6">
        <eps-label-body label="ORDERS.DELIVERY.LABELS.PLATE" readonly [labelWidth]="labelWidth">
          {{ deliveryMethod?.licensePlate ? deliveryMethod?.licensePlate : ('ORDERS.DELIVERY.LABELS.NO_LICENCE_PLATE' | translate) }}
        </eps-label-body>
      </div>
    </div>
  </form>
</div>
